const setLocalStorageItem = (key, value, seconds = 3600) => {
  const objectValue = {
    added: Date.now(),
    [key]: value,
    seconds,
  };

  localStorage.setItem(key, JSON.stringify(objectValue));
};

const getLocalStorageItem = key => {
  const item = JSON.parse(localStorage.getItem(key));

  if (!item) {
    return null;
  }

  // const timeNow = Date.now();
  // const { added, seconds } = item;

  // const timeAdded = Math.floor((timeNow - added) / 1000);

  // if (timeAdded > seconds) {
  //   removeLocalStorageItem(key);
  //   return null;
  // }

  return item[key];
};

export {
  setLocalStorageItem,
  getLocalStorageItem
};
